<template>
  <select ref="slSucursales" id="" class="form-control">
    <option value="-1">Seleccione un cliente</option>
    <option :value="sucursal._id" v-for="sucursal in sucursales" v-if="sucursal.empresa" :key="sucursal._id">{{sucursal.empresa.razonSocial}}-{{sucursal.denominacion}}</option>
  </select>
</template>
<script>
  import './../../assets/css/select2.css'
  import $ from 'jquery'
  import 'select2'
  import {sortBy} from 'lodash'
  export default {
    props: {
      value: {
        type: String,
        default: () => null
      }
    },
    data () {
      return {
        sucursales: []
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/admin/sucursales').then(({body}) => {
        me.sucursales = sortBy(body.sucursales, (sucursal) => {
          if (sucursal.empresa) {
            return sucursal.empresa.razonSocial + '-' + sucursal.denominacion
          }
        })
      }, (err) => {
        console.error(err)
      }).then(() => {
        $(me.$refs.slSucursales).select2({
          placeholder: 'Seleccione una empresa'
        }).on('change', () => {
          me.$emit('input', me.$refs.slSucursales.value)
          me.$emit('change-cliente', me.$refs.slSucursales.value)
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ComboEmpresasCliente.vue?7a3f47e8